<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">

      <el-form ref="update" :model="update" :rules="rules" size="small" label-width="100px">
        <div class="backborder3">
          <el-col :span="24">
            <el-col :span="7">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="update.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="编号" prop="number">
                <el-input v-model="update.number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="职员类型" prop="type">
                <el-select v-model="update.type" placeholder="请选择职员类型">
                  <el-option label="直营" value="1"></el-option>
                  <el-option label="合作" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-col>
        </div>
        <div class="backborder3" style="margin-top:10px">
          <el-col :span="24">
            <el-col :span="7">
              <el-form-item label="选择组别">
                <el-select v-model="update.groupid" placeholder="请选择客户分类">
                  <el-option v-for="(item, index) in grouplists" :label="item.name" :value="item.id"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="生日">
                <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="出生日期"
                  v-model="update.birthday"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-col>
        </div>
        <div class="backborder3" style="margin-top:10px">
          <el-col :span="24">
            <el-col :span="7">
              <el-form-item label="联系电话">
                <el-input v-model="update.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地址">
                <el-input v-model="update.address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="是否默认线上商城发货销售员" label-width="140">
                <el-radio-group v-model="update.ismall">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" align="right">
              <el-form-item>
                <el-button size="small" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
              </el-form-item>
            </el-col>
          </el-col>
        </div>
      </el-form>
    </div>
  </transition>
</template>

<script>

export default {
  props: ['childdata'],
  data() {
    return {
      actionauth: '', //功能权限
      transitionshow: true,
      url: this.GLOBAL.domain + "Clerk/index",
      update: {
        act: 'edit',
        token: this.$cookies.get('token'),
        id: '',
        name: '',
        number: '',
        birthday: '',
        phone: '',
        address: '',
        groupid: '',
        ismall: 0,
        type: '1'
      },
      groupLoading: false,
      group: {
        url: this.GLOBAL.domain + "Clerk/index",
        token: this.$cookies.get('token'),
        act: 'lists',
        name: '',
        id: '',
        p: 1,
        rollpage: 10000
      },
      grouplists: [],
      createLoading: false,
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符' }
        ],
        number: [
          { required: true, message: '请输入编号', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '编号只能为数字' }
        ],
        type: [
          { required: true, message: '请选择职员类型', trigger: 'blur' }
        ]
      },
      addclerkrules: {
        name: [
          { required: true, message: '请输入组别名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符' }
        ],
      },
      editclerkrules: {
        name: [
          { required: true, message: '请输入组别名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符' }
        ],
      },
      updateLoading: false,

    }
  },
  mounted() {
    this.getactionauth();
    this.getclerkgrouplists(); //获取职员组别信息
    this.getclerkinfos(); //获取职员信息

  },
  methods: {

    /** 获取功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    /** 获取职员组别列表 **/
    getclerkgrouplists() {
      this.creategroupDialog = true;
      this.groupLoading = true;
      this.group.act = 'getclerkgrouplists';
      var resource = this.$resource(this.group.url);
      resource.query(this.group).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
            this.groupLoading = false;
          }
          this.$message.error(res.data.Message);
          this.groupLoading = false;
        } else {
          this.grouplists = JSON.parse(Base64.decode(res.data.Data));
          this.groupLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.groupLoading = false;
      });
    },

    //获取职员信息
    getclerkinfos() {
      this.update.id = this.childdata.id;
      this.update.groupid = this.childdata.groupid;
      this.update.name = this.childdata.name;
      this.update.number = this.childdata.number;
      this.update.birthday = this.childdata.birthday;
      this.update.phone = this.childdata.phone;
      this.update.address = this.childdata.address;
      this.update.ismall = this.childdata.ismall == 1 ? 1 : 0;
      this.update.type = this.childdata.type;
    },


    //更新
    updateSave() {
      // 主动校验
      this.$refs.update.validate((valid) => {
        if (!valid) return false;
        this.updateLoading = true;
        var resource = this.$resource(this.url);

        resource.save(this.update).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.updateLoading = false;
          } else {
            this.$message.success(res.data.Message);
            this.updateLoading = false;
            this.$emit('closechild', 'Clerkedit'); //关闭窗口	
          }
        }).catch((res) => {
          this.updateLoading = false;
        });
      });
    },



  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder3 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  float: left;
  width: 98%;
  padding: 1% 1% 0 1%;
}
</style>


// WEBPACK FOOTER //
// src/components/base/Clerkedit.vue